module.exports = __webpack_public_path__ + "static/media/truck-icon.fbd32e87.png";